import React from "react";
import { LoadingDialog } from "../../../../../../_metronic/partials/control";

export interface ProductStocksLoadingDialogProps {
  color?: string
}
export const ProductStocksLoadingDialog: React.FC<ProductStocksLoadingDialogProps> = ({color}) => {
  return <LoadingDialog color={color} text="Cargando ..." />;
}



